import { useQuery } from "@tanstack/react-query";
import { getAllCategories } from "../services/categoryServices";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: getAllCategories,
  });
};
